// Port of api/fuel/app/classes/filter/package/games/play/data/games/counts.php
import Util from 'offline/util'
export default {
	require: function(config, filter) { return filter.play && filter.play.group },
	run: function(filter, data, config, global) {
		if (!global.gameIds || !global.gameIds.length) return
		var sql = 'SELECT game_id AS g, SUM(play_count) AS p, play_players AS c FROM play WHERE play_players > 0 AND game_id IN(' + Util.in(global.gameIds) + ') AND user_id IN(' + Util.in(global.userIndex) + ')'
		if (global.playContextIndex) sql += ' AND play_id IN(' + Util.in(global.playContextIndex) + ')'
		sql += ' GROUP BY game_id, play_players'
		global.counts = Util.query(sql, false, 'g', true)
		return global
	}
}
